import styled, { css } from 'styled-components';
import { remCalc, colors, media, layout } from '@prisjakt/ui-base';

const ratingWidth = '160px';

type UserReviewRowProps = {
  isMyReview: boolean;
};

export const UserReviewRow = styled.div<UserReviewRowProps>`
  display: flex;
  margin-top: ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.small};
  padding-bottom: ${p =>
    p.isMyReview ? layout.spacing.small : layout.spacing.xSmall};

  &:not(:last-of-type) {
    border-bottom: 1px solid ${p => p.theme.lines.primary};
  }

  ${media.mediumUp`
    margin-bottom: ${layout.spacing.small};
  `}

  ${media.mediumDown`
    flex-direction: column;
  `}
`;

export const MainBlock = styled.div`
  position: relative;
  max-width: 100%;
  width: 100%;
  padding: 0 ${layout.spacing.xSmall};
`;

export const Edit = styled.div`
  position: absolute;
  top: 2px;
  right: 45px;
`;

type TextLabelProps = {
  fullText?: boolean;
};

export const TextLabel = styled.div<TextLabelProps>`
  margin-top: ${remCalc(10)};
  white-space: pre-line;
  font-weight: 400;
  color: ${colors.darkBlue1};
  max-height: 9ex;
  overflow: hidden;

  ${props =>
    props.fullText &&
    css`
      max-height: none;
    `}
`;

export const Text = styled.div``;

export const ReadMore = styled.button`
  color: ${p => p.theme.text.linkExternal};
  text-decoration: underline;

  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
    cursor: pointer;
  }
`;

export const UsernameLabel = styled.span`
  color: ${p => p.theme.text.tertiary};
`;

export const User = styled.div`
  display: flex;
  align-items: center;

  a:hover {
    &,
    ${UsernameLabel} {
      color: ${p => p.theme.text.callToActionHover};
    }
  }

  ${media.mediumDown`
    margin-top: ${remCalc(10)};
  `}
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-around;
  overflow: hidden;
  font-size: ${remCalc(12)};
`;

export const ReviewCountLabel = styled.span`
  color: ${colors.mediumGray2};
  white-space: nowrap;
`;

export const UserAvatar = styled.div`
  flex-shrink: 0;
  margin-right: ${remCalc(5)};
`;

export const RatingWrapper = styled.div`
  display: flex;
  padding: 0 ${layout.spacing.xSmall};

  ${media.mediumDown`
    align-items: center;
  `}

  ${media.largeUp`
    flex-direction: column;
    max-width: ${ratingWidth};
    width: 100%;
  `}
`;

type DateLabelProps = {
  editDate?: boolean;
  purchaseDate?: boolean;
};

export const DateLabel = styled.div<DateLabelProps>`
  color: ${p => p.theme.text.secondary};

  ${media.mediumDown`
    margin-left: ${remCalc(10)};
    margin-bottom: -3px;
  `}

  ${props =>
    props.editDate &&
    props.purchaseDate &&
    css`
      color: ${p => p.theme.text.tertiary};
    `}
`;

export const TranslationOptions = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${p => p.theme.text.tertiary};
`;

export const TranslationOptionsService = styled.div`
  margin-right: 1em;
  img {
    margin-top: 2px;
    height: 18px;
  }
`;

export const TranslationOptionsToggle = styled.div`
  button {
    cursor: pointer;
    color: ${p => p.theme.text.tertiary};
    text-decoration: underline;
  }
`;

export const Actions = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  svg {
    fill: ${p => p.theme.icons.tertiary};
    &:hover {
      fill: ${colors.darkGray3};
    }
  }

  .ui-dropdown--toggle-button {
    padding-top: 0;
    padding-bottom: 0;
  }

  ${media.mediumDown`
    top: 10px;
  `}
`;

export const Reply = styled.div`
  background-color: ${colors.semiWhite};
  margin-top: ${remCalc(20)};
  padding: ${remCalc(10)};
  border-radius: ${remCalc(6)};
`;

export const ReplyName = styled.div`
  margin-bottom: ${remCalc(3)};
  color: ${colors.darkGray1};
  font-size: ${remCalc(12)};
`;

export const ReplyDate = styled.span`
  float: right;
`;

export const ReplyText = styled.div`
  white-space: pre-line;
`;

type HelpfulButtonProps = {
  liked: boolean;
};

export const HelpfulButton = styled.button<HelpfulButtonProps>`
  margin-top: ${layout.spacing.small};
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${p =>
    p.liked ? p.theme.text.callToActionHover : p.theme.text.callToAction};
  cursor: pointer;
  padding: ${layout.spacing.xSmall};

  span {
    overflow: hidden;
    transition: max-width 150ms ease;
    max-width: 100px;
    max-width: ${p => (p.liked ? 0 : '100px')};
  }

  && {
    svg {
      margin-right: ${layout.spacing.xSmall};
    }
  }

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;
